import { useNavigate } from 'react-router-dom'

import i18n from 'modules/core/lib/i18n'

import { useMarketplaceModulesPath } from 'modules/marketplace_modules/hooks/useMarketplaceModulesPath'
import { buildUpsellOriginParam } from 'modules/upselling_kit/utils/handlers'

interface UseDefaultMessagesOptions {
  component?: string
  requestSource?: string
}

export const useDefaultMessages = (options?: UseDefaultMessagesOptions) => {
  const navigate = useNavigate()
  const { getListPath } = useMarketplaceModulesPath()
  const { component, requestSource } = options || {}

  return {
    error: {
      title: i18n.t('upselling_kit.upselling_button.error_message.title'),
      description: i18n.t('upselling_kit.upselling_button.error_message.description'),
    },
    success: {
      title: i18n.t('upselling_kit.upselling_button.success_message.title_2'),
      description: i18n.t('upselling_kit.upselling_button.success_message.description'),
      buttonLabel: i18n.t('upselling_kit.upselling_button.success_message.button_label'),
      buttonOnClick: () => {
        if (component && requestSource) {
          const upsellOriginParam = buildUpsellOriginParam(component, requestSource, 'Upselling Kit')
          navigate(getListPath(upsellOriginParam))
        } else {
          navigate(getListPath())
        }
      },
    },
    nextSteps: {
      title: i18n.t('upselling_kit.upselling_button.next_steps.title'),
      items: [
        { text: i18n.t('upselling_kit.upselling_button.next_steps.item_1'), isCompleted: true },
        { text: i18n.t('upselling_kit.upselling_button.next_steps.item_2'), isCompleted: false },
        { text: i18n.t('upselling_kit.upselling_button.next_steps.item_3'), isCompleted: false },
      ],
    },
    loading: {
      label: i18n.t('upselling_kit.upselling_button.loading_state.label'),
    },
    close: i18n.t('upselling_kit.upselling_button.close_label'),
  }
}
